<template>
  <div class="create-edit-access">
    <div class="card__header">
      <span class="card__header--topic">Access Card List</span>
    </div>
    <div v-if="currentAccessList.length">
      <div
        v-for="(access, index) in currentAccessList"
        :key="index"
        class="access-container"
      >
        <div class="access-header mt-2">Access Card {{ index + 1 }}</div>
        <div class="access-detail">
          <div class="d-flex justify-content-between">
            <span class="location-name">
              {{ access.siteName ? access.siteName : "Site Not Found" }}
              -
              {{ access.locationName }}
            </span>
            <div v-if="hasEditPermission" class="icon-container d-flex">
              <div
                class="icon-wrapper"
                @click="onClickEditAccess(access, index)"
              >
                <feather-icon
                  class="icon-size-20px"
                  icon="EditIcon"
                ></feather-icon>
              </div>
              <div
                class="ml-1 icon-wrapper"
                @click="onClickDeleteAccess(access, index)"
              >
                <feather-icon
                  class="icon-size-20px"
                  icon="Trash2Icon"
                ></feather-icon>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-between">
            <span class="access-card-number"
              >Access Card Number: <b>{{ access.accessCardNumber }}</b></span
            >
          </div>
          <hr />
        </div>
      </div>
    </div>
    <div v-if="hasEditPermission" class="button-wrapper">
      <div class="button-dash box-dashed" @click="onClickAddNewAccess">
        <feather-icon
          class="icon-size-24px text-primary"
          icon="PlusCircleIcon"
        ></feather-icon>
        <label class="button--text">Add New Access</label>
      </div>
    </div>

    <!-- start modal section -->
    <!-- start modal delete -->
    <molecule-modal-dialog
      modalId="modal-confirm-delete-access"
      icon="AlertCircleIcon"
      textTitle="Do you want to delete ?"
      buttonTextLeft="Delete"
      buttonColorLeft="danger"
      :isTextCenter="true"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      @clickButtonLeft="onClickConfirmDeleteFromModal"
    >
      <template #body>
        <div class="modal-confirm-delete-access-body">
          <label class="text-center text--subtitle-modal">
            Access ID: {{ targetAccess.accessCardNumber }} At
            {{ targetAccess.siteName }} - {{ targetAccess.locationName }}<br />
            will be deleted from this contact point/sale.
          </label>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal delete -->

    <!-- start modal add new access -->
    <molecule-modal-dialog
      modalId="modal-add-access"
      buttonTextLeft="Add"
      buttonColorLeft="primary"
      textTitle="Add New Access"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      @clickButtonLeft="onClickConfirmAddNewAccessFromModal"
      @clickButtonRight="onClickCancelAddNewAccessFromModal"
      @clickIconClose="onClickCancelAddNewAccessFromModal"
    >
      <template #body>
        <div class="select-location-container w-80 mt-1">
          <atom-select
            v-model="newAccess.location"
            title="Location"
            placeholder="Select Location"
            label="label"
            :isAsterisk="true"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtNewSelectLocation"
            :errorMessage="errorMessageAtSelector"
            :option="locationOption"
          ></atom-select>
        </div>
        <div class="access-card-number-container w-80 mt-1">
          <atom-input
            v-model="newAccess.accessCardNumber"
            title="Access Card Number"
            placeholder="Access Card Number"
            :isAsterisk="true"
            :isError="isErrorAtNewAccessCardNumber"
            :errorMessage="errorMessageAtInput"
          ></atom-input>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal add new access -->

    <!-- start modal edit access -->
    <molecule-modal-dialog
      modalId="modal-edit-access"
      buttonTextLeft="Save Change"
      buttonColorLeft="primary"
      textTitle="Edit Access"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      @clickButtonLeft="onClickConfirmEditAccessFromModal"
      @clickButtonRight="onClickCancelEditAccessFromModal"
      @clickIconClose="onClickCancelEditAccessFromModal"
    >
      <template #body>
        <div class="select-location-container w-80 mt-1">
          <atom-select
            v-model="targetLocation"
            title="Location"
            placeholder="Select Location"
            label="label"
            :isAsterisk="true"
            :isClearable="false"
            :isAppendToBody="false"
            :isEnableProper="false"
            :isError="isErrorAtEditSelectLocation"
            :errorMessage="errorMessageAtSelector"
            :option="locationOption"
          ></atom-select>
        </div>
        <div class="access-card-number-container w-80 mt-1">
          <atom-input
            v-model="targetAccess.accessCardNumber"
            title="Access Card Number"
            placeholder="Access Card Number"
            :isAsterisk="true"
            :isError="isErrorAtEditAccessCardNumber"
            :errorMessage="errorMessageAtInput"
          ></atom-input>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal edit access -->

    <!-- end modal section -->
  </div>
</template>

<script>
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import mixinsValidators from "@/mixins/mixinsValidator"
import mixinsObjectHelper from "@/mixins/mixinsObjectHelper"

export default {
  name: "MoleculeCreateEditAccess",
  components: { AtomInput, AtomSelect, MoleculeModalDialog },
  props: {
    locationOption: {
      type: Array,
      required: true,
    },
    hasEditPermission: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Array,
      required: false,
      default: null,
    },
  },
  mixins: [mixinsValidators, mixinsObjectHelper],
  data() {
    return {
      modalId: null,
      isValidateNewAccessInModalTrigger: false,
      isValidateEditAccessInModalTrigger: false,
      isDataChange: false,
      errorMessageAtInput: "Please enter valid data",
      errorMessageAtSelector: "Please select data",
      targetAccess: {
        accessCardNumber: "",
      },
      newAccess: {
        location: null,
        accessCardNumber: "",
      },
      targetLocation: {
        label: "",
        locationId: "",
        locationName: "",
      },
    }
  },
  computed: {
    currentAccessList: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
    isErrorAtEditSelectLocation() {
      return this.isValidateEditAccessInModalTrigger
        ? this.isEmptyString(this.targetLocation?.locationName)
        : false
    },
    isErrorAtEditAccessCardNumber() {
      return this.isValidateEditAccessInModalTrigger
        ? this.isEmptyString(this.targetAccess.accessCardNumber)
        : false
    },
    isErrorOccurAtEditSelectAccessCard() {
      return (
        this.isErrorAtEditSelectLocation || this.isErrorAtEditAccessCardNumber
      )
    },
    isErrorAtNewSelectLocation() {
      return this.isValidateNewAccessInModalTrigger
        ? this.isEmptyObject(this.newAccess.location)
        : false
    },
    isErrorAtNewAccessCardNumber() {
      return this.isValidateNewAccessInModalTrigger
        ? this.isEmptyString(this.newAccess.accessCardNumber)
        : false
    },
    isErrorOccurAtNewSelectAccessCard() {
      return (
        this.isErrorAtNewSelectLocation || this.isErrorAtNewAccessCardNumber
      )
    },
    
  },
  methods: {
    setDefaultTargetValue() {
      this.targetAccess = {
        accessCardNumber: "",
      }
      this.targetLocation = {
        label: "",
        locationId: "",
        locationName: "",
      }
    },
    setDefaultNewAccess() {
      this.newAccess = {
        siteName: "",
        location: null,
        accessCardNumber: "",
      }
    },
    editAccess() {
      const targetIndex = this.targetAccess.index
      const newAccessValue = {
        siteName: this.targetLocation.siteName,
        locationId: this.targetLocation.locationId,
        locationName: this.targetLocation.locationName,
        accessCardNumber: this.targetAccess.accessCardNumber,
      }
      this.$set(this.currentAccessList, targetIndex, newAccessValue)
    },
    deleteAccess() {
      const targetIndex = this.targetAccess.index
      this.currentAccessList.splice(targetIndex, 1)
    },
    onClickAddNewAccess() {
      this.setDefaultTargetValue()
      this.modalId = "modal-add-access"
      this.$bvModal.show(this.modalId)
    },
    onClickEditAccess(access, index) {
      this.targetAccess = {
        ...access,
        index: index,
      }
      this.targetAccess.location = this.locationOption.find(
        (location) => location.locationName === this.targetAccess.locationName
      )
      this.targetLocation = this.deepCopyObject(this.targetAccess.location)
      this.modalId = "modal-edit-access"
      this.$bvModal.show(this.modalId)
    },
    onClickDeleteAccess(access, index) {
      this.targetAccess = {
        ...access,
        index: index,
      }
      this.modalId = "modal-confirm-delete-access"
      this.$bvModal.show(this.modalId)
    },
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },
    onClickConfirmDeleteFromModal() {
      this.deleteAccess()
      this.setDefaultTargetValue()
      this.closeModal()
    },
    onClickConfirmAddNewAccessFromModal() {
      this.isValidateNewAccessInModalTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorOccurAtNewSelectAccessCard) {
          const newAccessData = {
            siteName: this.newAccess.location.siteName,
            locationId: this.newAccess.location.locationId,
            locationName: this.newAccess.location.locationName,
            accessCardNumber: this.newAccess.accessCardNumber,
          }
          this.currentAccessList = [...this.currentAccessList, newAccessData]
          this.setDefaultNewAccess()
          this.closeModal()
          this.isValidateNewAccessInModalTrigger = false
        }
      })
    },
    onClickCancelAddNewAccessFromModal() {
      this.setDefaultNewAccess()
    },

    onClickConfirmEditAccessFromModal() {
      this.isValidateEditAccessInModalTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorOccurAtEditSelectAccessCard) {
          this.editAccess()
          this.closeModal()
          this.setDefaultTargetValue()
          this.isValidateEditAccessInModalTrigger = false
        }
      })
    },
    onClickCancelEditAccessFromModal() {
      this.setDefaultTargetValue()
    },
  },
}
</script>

<style lang="scss" scoped>
.create-edit-access ::v-deep input.vs__search::placeholder {
  color: #b9b9c3;
}

.create-edit-access {
  padding: 21px;
}

.card__header--topic {
  font-weight: 500;
  font-size: 18px;
}

.button-dash {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.button-wrapper {
  width: 300px;
}

.button--text {
  margin-left: 10px;
  margin-bottom: 0;
  color: #7367f0;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}

.box-dashed {
  height: 60px;
  border: 1px dashed rgba(115, 103, 240, 0.4);
  box-sizing: border-box;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
  &:hover {
    background-color: #f9f9fe;
  }
}

.access-header {
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  color: #b9b9c3;
}

.access-detail {
  margin-top: 9px;
}

.location-name {
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  color: #82868b;
}

.icon-wrapper:hover {
  cursor: pointer;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .access-detail,
  .button-wrapper {
    width: 550px;
  }
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}
</style>
